import {observer} from "mobx-react";
import {Typography} from "@bezlimit/bezlimit-ui";
import "./style.scss";
import _ from "lodash";
import {useContext} from "react";
//images
import plusOutlined from "../../../../../../images/plusoutlined.png";
//core
import {LayoutContext} from "../../../../../../core/Contexts";

export default observer(function UploadBtn({title, images}: IProps) {
    const contextLayout = useContext(LayoutContext);
    return (
        <div className="conteiner-upload-btn">
            <img
                src={plusOutlined}
                width={_.gte(contextLayout?.width ?? 0, 768) ? 101 : 56}
                alt=""
                className="plus-outlined"
            />
            <img
                src={images}
                width={_.gte(contextLayout?.width ?? 0, 768) ? 230 : 120}
                alt=""
                className="passport"
            />
            <Typography as="div" className="text">
                {title}
            </Typography>
        </div>
    );
});

interface IProps {
    title: string;
    images?: any;
}
